import {AfterViewInit, Component, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {NgModel} from '@angular/forms';
import {AutoSaveService} from '../../../../services/auto-save.service';
import {Subscription} from 'rxjs';
import {ShareService} from "../../../../services/share.service";
import {ValidationService} from "../../../../services/validation.service";
import {debounceTime} from "rxjs/operators";
import {PhotosModel} from '../../../../models/data-models/photos-model';
import {GeneralPrePhotosModel} from '../../../../models/data-models/general-pre-photos-model';
import {ConverterService} from "../../../../services/converter.service";
import {DeviceDataService} from "../../../../services/device-data.service";
import {Dialog} from "@angular/cdk/dialog";

@Component({
  selector: 'app-install-photos',
  templateUrl: './install-photos.component.html',
  styleUrls: ['./install-photos.component.scss'],

})
export class InstallPhotosComponent implements OnInit, AfterViewInit, OnDestroy {
  public model: PhotosModel = new PhotosModel();
  public prePhotos: GeneralPrePhotosModel = new GeneralPrePhotosModel();

  @ViewChildren(NgModel) inputs: QueryList<NgModel>;
  private inputSubscriptions: Subscription[] = [];
  private readonly modelSub: Subscription;
  private readonly prePhotosSub: Subscription;

  public readonly LOW_IMAGE_QUALITY = AutoSaveService.LOW_IMAGE_QUALITY;

  constructor(
    private shareService: ShareService,
    public validationService: ValidationService,
    private converterService: ConverterService,
    private deviceDataService: DeviceDataService,
    private dialog: Dialog,
  ) {
    this.model = this.shareService.photos || new PhotosModel();
    this.modelSub = this.shareService.photos$.subscribe((data) => {
      this.model = data || new PhotosModel();
      this.initImagesArrays();
    });
    this.prePhotos = this.shareService.generalPrePhotos || new GeneralPrePhotosModel();
    this.prePhotosSub = this.shareService.generalPrePhotos$.subscribe((data) => {
      this.prePhotos = data || new GeneralPrePhotosModel();
      this.prePhotos.preInstallHeatingImages = this.prePhotos.preInstallHeatingImages || [{image: null}];
      this.initImagesArrays();
    });
    this.initImagesArrays();
  }

  ngOnInit(): void {
  }

  initImagesArrays() {
    if (!this.model.postInstallHeatingImages?.length) {
      this.model.postInstallHeatingImages = this.model.postInstallHeatingImages || [];
      while (this.model.postInstallHeatingImages.length < this.prePhotos.preInstallHeatingImages.length) {
        this.model.postInstallHeatingImages.push({image: null});
      }
    }
  }

  ngAfterViewInit(): void {
    this.inputs.forEach(input => {
      this.inputSubscriptions.push(input.control.valueChanges.pipe(
        debounceTime(500)
      ).subscribe(() => {
        this.shareService.photos = this.model;
      }));
    });

    // Subscribe to changes in the list of inputs
    // (it is called if some input is added or removed from the form/page,
    // for example, because of *ngIf condition changes)
    this.inputs.changes.subscribe(() => {
      // Unsubscribe from old subscriptions
      this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());

      // Subscribe to new inputs
      this.inputs.forEach(input => {
        this.inputSubscriptions.push(input.control.valueChanges.pipe(
          debounceTime(500)
        ).subscribe(() => {
          this.shareService.photos = this.model;
        }));
      });
    });
  }

  isInvalid(): boolean {
    return !this.model?.installationBoxImage ||
      !this.model?.antennaImage ||
      !this.model?.schemeImage ||
      (this.model?.postInstallBoilerRoomImages?.length >= 1 && !this.model?.postInstallBoilerRoomImages[0]?.image) ||
      (this.model?.postInstallBoilerRoomImages?.length >= 2 && !this.model?.postInstallBoilerRoomImages[1]?.image) ||
      (this.model?.postInstallBoilerRoomImages?.length >= 3 && !this.model?.postInstallBoilerRoomImages[2]?.image);
  }

  isCompleted(): boolean {
    return this.model?.installationBoxImage !== undefined && this.model?.installationBoxImage !== null &&
      this.model?.antennaImage !== undefined && this.model?.antennaImage !== null &&
      this.model?.schemeImage !== undefined && this.model?.schemeImage !== null &&
      this.model?.postInstallBoilerRoomImages?.length >= 3 &&
      this.model?.postInstallBoilerRoomImages[0]?.image !== undefined && this.model?.postInstallBoilerRoomImages[0]?.image !== null &&
      this.model?.postInstallBoilerRoomImages[1]?.image !== undefined && this.model?.postInstallBoilerRoomImages[1]?.image != null &&
      this.model?.postInstallBoilerRoomImages[2]?.image !== undefined && this.model?.postInstallBoilerRoomImages[2]?.image != null &&
      this.model?.postInstallHeatingImages.length >= this.prePhotos.preInstallHeatingImages.length &&
      this.model?.postInstallHeatingImages.every((item, index) => (item?.image !== undefined && item?.image !== null) || index >= (this.prePhotos.preInstallHeatingImages.length - 1))
      ;
  }

  updateHeatingImages(value: any, index: number) {
    const length = this.prePhotos.preInstallHeatingImages.length;
    if (value === null && index >= length) {
      this.model.postInstallHeatingImages.splice(index, 1);
    } else if (value === null && index < length) {
      this.model.postInstallHeatingImages[index].image = null;
    } else {
      let areAllRequiredImagesFilledOut = true;
      for (const item of this.model.postInstallHeatingImages) {
        if (item?.image === null) {
          areAllRequiredImagesFilledOut = false;
          break;
        }
      }
      if (areAllRequiredImagesFilledOut) {
        this.model.postInstallHeatingImages.push({image: null});
      }
    }
  }

  ngOnDestroy(): void {
    this.inputSubscriptions?.forEach(subscription => subscription.unsubscribe());
    if (this.modelSub) {
      this.modelSub.unsubscribe();
    }
    if (this.prePhotosSub) {
      this.prePhotosSub.unsubscribe();
    }
  }
}
